import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";

const state = {
    employees: [],
    employee: {},
    totalItems:0,

};

const getters = {
    index: state => healthInfoId => state.employees.findIndex(i => i.healthInfoId === healthInfoId)
};

const mutations = {
    setEmployees: (state, r) => (state.employees = r),
    setEmployee: (state, r) => (state.employee = r),
    setTotalItems: (state, r) => (state.totalItems = r),
    add: (state, r) => state.employees.unshift(r),
    //edit: (state, {index,  r }) => state.employees.splice(index, 1, r),
    delete: (state, index) => state.employees.splice(index, 1),

};

const actions = {
    async getAll({ commit }, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            startLoading()
            const response = await dataService.employeeHealth.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setEmployees", response.data.employees);
            commit("setTotalItems", response.data.totalItems);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getDetails({ commit }, id) {
        try {
            commit("setEmployee", {});
            startLoading()
            const response = await dataService.employeeHealth.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setEmployee", response.data.healthInfo);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.employeeHealth.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data.healthInfo);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, id) {
        try {

            startLoading()
            const response = await dataService.employeeHealth.add(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);
            commit("add", response.data.employeeHealth);
        } catch (error) {
            console.log(error)
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async edit(_, { id, payload }) {
        try {
            let formData = new FormData()

            //const formData = new FormData();
            formData.append("employeeId", payload.employeeId);
            payload.items.forEach((tag, index) => {
                formData.append(`Items[${index}].healthDiseaseId`, tag.healthDiseaseId);
                formData.append(`Items[${index}].typeId`, tag.typeId);
                formData.append(`Items[${index}].description`, tag.description);
                formData.append(`Items[${index}].attachmentFile`, tag.attachmentFile);
                formData.append(`Items[${index}].fileName`, tag.fileName);
            });
         console.log(payload);
         console.log(formData);

              startLoading()
            const response = await dataService.employeeHealth.edit(id, formData);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);

            //const index = getters.index(id);
            //commit("edit", { index, r: response.data.employeeHealth });
            return Promise.resolve()
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.employeeHealth.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);
            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },



};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
